/**
 * @generated SignedSource<<1e98bdab367a3ad298a4becb7ed90bf7>>
 * @relayHash 756bdda02296671babf53e2fbb90e82d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 76d640337689c680828044e22a7b075fdbda04933a7fb55925a4b35eb5d54356

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { FilterRefinementTimelineQuery } from './FilterRefinementTimelineQuery.graphql';

import isJiraAiAgentAvatarFilterComponentEnabled_provider from '@atlassian/jira-relay-provider/src/jira-ai-agent-avatar-filter-component.relayprovider';

const node: PreloadableConcreteRequest<FilterRefinementTimelineQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "76d640337689c680828044e22a7b075fdbda04933a7fb55925a4b35eb5d54356",
    "metadata": {},
    "name": "FilterRefinementTimelineQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarfiltercomponentrelayprovider": isJiraAiAgentAvatarFilterComponentEnabled_provider
    }
  }
};

export default node;
